export default function BillingPaymentMethod() {
  return (
    <div className="tw-block tw-h-24 tw-w-full tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-md">
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
        <strong>Payment Method</strong>
        <div className="tw-text-squash-600 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline">
          Update payment method
        </div>
      </div>
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
        <div>Checking 0872</div>
        <div>ACH</div>
      </div>
    </div>
  )
}
